import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

export default class AutoclosableController extends Controller<HTMLDetailsElement> {
  clickOutside(): void {
    if (this.element.open) {
      this.close();
    }
  }

  close(): void {
    this.element.removeAttribute("open");
  }

  connect(): void {
    useClickOutside(this);
  }

  open(): void {
    this.element.open = true;
  }
}
